import BaseTabSchema from 'root-packages/tabSchemaValidation/baseTabSchema.js'

class ConfirmationTabSchema extends BaseTabSchema {
  constructor (options) {
    super(options)
    this.config = options.config
  }
  phoneNumberCountryCode (field) {
    return (value, is) => {
      is(this.passengersSchemaFunctions.present(field))
    }
  }

  phoneNumber () {
    return (value, is, object) => {
      if (is(this.number())) {
        const length = object.number.toString().length
        if (length < 6 || length > 11) {
          return this.config.errorMessages.mobileNumberInvalid
        }
      }
    }
  }

  buildSchema () {
    return {
      leadPassenger: {
        emailAddress: this.email(),
        mobileNumber: this.config.phoneNumberAsString ? this.phoneNumberAsString() : {
          internationalCode: this.phoneNumberCountryCode(),
          number: this.phoneNumber(),
          numberWhileAway: undefined,
        },
      },
    }
  }
}

export default ConfirmationTabSchema
